import { render } from "./DashobardPaymentInvoicePage.vue?vue&type=template&id=6cfde7c8"
import script from "./DashobardPaymentInvoicePage.vue?vue&type=script&lang=js"
export * from "./DashobardPaymentInvoicePage.vue?vue&type=script&lang=js"

import "./DashobardPaymentInvoicePage.vue?vue&type=style&index=0&id=6cfde7c8&lang=css"

import exportComponent from "/opt/1psim/portal_test/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__